import React from 'react';

const TorExitNodeAdapterDocumentation = () => <div />;

export default TorExitNodeAdapterDocumentation;
